// extracted by mini-css-extract-plugin
export default {"wrapper":"OnboardingCustomizing_wrapper__63mc3","container":"OnboardingCustomizing_container__mJosO","logo":"OnboardingCustomizing_logo__yB1C1"};